var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tag
    ? _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12", "order-md": "2" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-center justify-md-end" },
                  [
                    _c("action-buttons", {
                      staticClass: "d-flex justify-end",
                      attrs: {
                        state: _vm.editState,
                        permissions: _vm.userPermission,
                        disabled: _vm.isLoading,
                        "is-dirty": _vm.isDirty
                      },
                      on: {
                        save: _vm.handleSave,
                        cancel: _vm.handleCancel,
                        close: _vm.handleClose
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Tag Text" },
                        on: {
                          change: function($event) {
                            _vm.isDirty = true
                          }
                        },
                        model: {
                          value: _vm.tag.text,
                          callback: function($$v) {
                            _vm.$set(_vm.tag, "text", $$v)
                          },
                          expression: "tag.text"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.entityTypes,
                          label: "Entity Types",
                          multiple: "",
                          chips: ""
                        },
                        on: {
                          change: function($event) {
                            _vm.isDirty = true
                          }
                        },
                        model: {
                          value: _vm.tag.entityTypes,
                          callback: function($$v) {
                            _vm.$set(_vm.tag, "entityTypes", $$v)
                          },
                          expression: "tag.entityTypes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }